import { ROUTES } from 'src/constants';

// CON-2014 — the Short codes entry in Connections and one code's thread.
export const SHORT_CODES_PATH = `${ROUTES.APP_MANAGEMENT_CHAT}/short-codes`;

export const shortCodeThreadPath = (code) => `${SHORT_CODES_PATH}/${code}`;

// Shown under every short-code thread in place of the message box.
export const SHORT_CODE_NO_REPLY_NOTE = 'Connection Point can\'t reply to short codes. '
  + 'To stop these texts, use the sender\'s website or app.';
